import React, { useEffect } from 'react';
import { Button, notification } from 'antd';

// Build con el que cargó este bundle (inyectado por scripts/build-with-version.js).
// En dev no existe y el watcher queda desactivado.
const INITIAL_BUILD_ID = process.env.REACT_APP_BUILD_ID;

const CHECK_INTERVAL_MS = 5 * 60 * 1000;
const POST_MOUNT_CHECK_MS = 1500;
const NOTIFICATION_KEY = 'version-update';

const showUpdateNotification = () => {
  // key fija: si la notificación ya está abierta, antd la actualiza en lugar
  // de duplicarla; si el usuario logró cerrarla, el siguiente check la re-abre.
  notification.open({
    key: NOTIFICATION_KEY,
    message: 'Hay una actualización disponible',
    description:
      'Guarda tu trabajo pendiente y da clic en Actualizar para usar la última versión.',
    duration: 0,
    closeIcon: <span />,
    btn: (
      <Button type="primary" onClick={() => window.location.reload()}>
        Actualizar
      </Button>
    ),
  });
};

export default function VersionWatcher() {
  useEffect(() => {
    if (!INITIAL_BUILD_ID) return undefined;

    const check = async () => {
      try {
        const resp = await fetch('/version.json', { cache: 'no-store' });
        if (!resp.ok) return;
        const { buildId } = await resp.json();
        if (buildId && buildId !== INITIAL_BUILD_ID) {
          showUpdateNotification();
        }
      } catch (err) {
        // Sin red o respuesta inválida: silencioso, nunca molestar al usuario.
      }
    };

    const onVisibility = () => {
      if (document.visibilityState === 'visible') check();
    };

    const timeoutId = setTimeout(check, POST_MOUNT_CHECK_MS);
    const intervalId = setInterval(check, CHECK_INTERVAL_MS);
    window.addEventListener('focus', check);
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
      window.removeEventListener('focus', check);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);

  return null;
}
